import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Logo from "./Logo";

export default function SiteHeader({ active }) {
  const isActive = (name) =>
    active === name ? "text-[#F8FAFC]" : "text-[#94A3B8] hover:text-[#F8FAFC]";

  return (
    <header className="relative z-10 border-b border-[#1E293B]">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-6 py-5 lg:px-8">
        <Link to="/" className="inline-flex">
          <Logo size={28} />
        </Link>
        <nav className="hidden items-center gap-7 md:flex">
          <Link to="/about" className={"font-body text-sm transition-colors " + isActive("about")}>
            About
          </Link>
          <Link to="/pilot" className={"font-body text-sm transition-colors " + isActive("pilot")}>
            Pilot
          </Link>
          <Link to="/contact" className={"font-body text-sm transition-colors " + isActive("contact")}>
            Contact
          </Link>
          <Link
            to="/walkthrough"
            className="group inline-flex items-center gap-1.5 rounded-md bg-[#22C55E] px-4 py-2 font-body text-sm font-semibold text-[#07111F] transition-colors hover:bg-[#22C55E]/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#22C55E]/40"
            data-testid="header-cta-walkthrough"
          >
            Request Private Walkthrough
            <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </nav>
      </div>
    </header>
  );
}
